import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Popover,
  MenuItem,
  Box
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { getUser } from '../services/user';
const user = {
    name: 'Jane Doe',
    avatar: 'https://i.pravatar.cc/150?img=5'
};

const HeaderTest = ({ onMenuClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const user = getUser();

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={onMenuClick}>
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Home
        </Typography>
        <IconButton onClick={handleAvatarClick}>
          <Avatar alt={user.name} src={user.picture} />
        </IconButton>
        <Popover
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Box sx={{ p: 2 }}>
            <Typography>{user.name}</Typography>
            <MenuItem>Preferences</MenuItem>
            <MenuItem>Logout</MenuItem>
          </Box>
        </Popover>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderTest;